import React, { Component } from 'react';
import { fileController } from "../viewer/Controllers/index";
import { store } from 'Store/store.index';
import { Modal, Spin } from 'antd';
import './fwDocsIframe.scss';
import {isMacSsoNoIos} from 'Utils/device';
import { isSafari } from 'Utils/browser-info';
// import utils from "@foxit/utils";
import FwDocsMac from '@/components/fwDocMac/fwDocs'//TODO FOXIT 云文档

export default class fwDocsIframe extends Component {
  constructor(props) {
    super(props);
    this.event = this.event.bind(this);
    this.openUrlFile = this.openUrlFile.bind(this);
    this.messageListener = this.messageListener.bind(this);
    // this.onCloseCloudDocs = this.onCloseCloudDocs.bind(this);
    this.state = {
      isModalVisible: true,
      clickOpenUrl: false,
      boxHeight: "",
      loading: false,
      iframeUrl: "https://docs.foxitcloud.cn/Iframe" // 默认sso登录打开的云文档iframe页面链接
    }
  }
  componentDidMount() {
    console.log('fwDocsIframe')
    this.event();
    this.getHeight()
    // 判断是否iam登录，修改iframe的链接
    if(store.loginNewStore.IAMToken) {
      this.setState({
        iframeUrl: "https://docs.foxitcloud.cn/Iframe?loginType=iam"
        // iframeUrl: "https://www.foxitcloud.cn/singleSign"
      })
    }
  }
  componentWillUnmount() {
    window.removeEventListener('message',this.messageListener);
  }
  /**
   * [event 事件绑定]
   *
   * @return  {[type]}  [return description]
   */
  event(){
    window.addEventListener('message',this.messageListener, false);
  }
  messageListener(e){
    if (this.state.clickOpenUrl) {
      return
    }
    if(e.data.fileName){
      // TODO FOXIT 这个注释掉的逻辑用于处理云文档非PDF文件跳转云编辑时进行转换，但当前云文档非pdf文件默认下载，暂时不做调整，因此该逻辑注释，暂不使用。
      // console.log(decodeURIComponent(e.data.url))
      // console.log(e.data.fileName)
      // utils.util.urlToBlob(decodeURIComponent(e.data.url)).then(async (blob) =>{
      //   console.log(blob)
      //   store.convert.openFileBeforeConvert(blob, e.data.fileName);
      // })
      
      let clickFunc = () => {
        store.appStore.hideOpenFileDlg();
        this.setState({
          clickOpenUrl: true
        })
        this.openUrlFile(decodeURIComponent(e.data.url), e.data.fileName);
      }
      if(!window.pdfui) {
        this.setState({
          loading: true
        })
        this.props.doInitializePDFViewerUI(window._UIExtension, clickFunc)
      } else {
        clickFunc()
      }
    }
  }
  /**
   * [openUrlFile 打开云文档文件]
   *
   * @param   {[type]}  url       [url 文件url]
   * @param   {[type]}  fileName  [fileName 文件名]
   *
   * @return  {[type]}            [return description]
   */
  openUrlFile(url, fileName = ''){
    const { onShowToSaveBeforeOpen, docModified } = store.appStore;
    if (docModified) {
      onShowToSaveBeforeOpen((isToSave) => {
        !isToSave && store.appStore.doUpdateDocModified(false);
        // !isToSave && store.appStore.backToHomeStart();
        !isToSave && this._doOpenFileByUrl(url, fileName)
        isToSave && this.setState({
          clickOpenUrl: false
        })
      });
    } else {
      this._doOpenFileByUrl(url, fileName)
    }
  }
  _doOpenFileByUrl = (url, fileName) => {
    fileController.doOpenFileByUrl(url, fileName,(/*err*/) => {
      this.setState({
        clickOpenUrl: false
      })
    }, true, async () => {
      this.setState({
        clickOpenUrl: false,
        loading: false
      })
      this.props.closeDocs();
      // !云文档占时不直接打开分享
      // 这里获取docId, 用于云文档打開分享
      // if(url.includes("docId")) {
      //   let docId = ""
      //   let docIdArr = url.split("?")[1].split("&")
      //   docIdArr.forEach(item => {
      //     let arr = item.split("=")
      //     if(arr[0] === "docId") {
      //       docId = arr[1]
      //     }
      //   })
      //   store.shareStore.setShareDocId(docId)
      //   // TODO FOXIT 协同操作添加接口，这里需要处理当打开文件后，使用docId调用该文件是否已发起分享的接口。若已协同，则获取reviewShareId，查询文件的协同状态，协同中进入协同，已关闭则不做处理。
      //   let docReviewRessionIdResulet = await collaborationApi.getDocReviewRessionId(docId)
      //   if(docReviewRessionIdResulet && docReviewRessionIdResulet.ret === 0) {
      //     if(docReviewRessionIdResulet.data) {
      //       store.collaborationStore.setReviewSessionID(docReviewRessionIdResulet.data)
      //       store.collaborationStore.openCPDFTocllaborationMode();
      //     }
      //   }
      // }
    });
  }
  getWidth = () => {
    return document.body.clientWidth > 1010 ? "1000px" : "98%"
  }
  getHeight = () => {
    setTimeout(() => {
      this.setState({
        boxHeight: "610px"
      })
    },100)
  }
  render() {
    const {
      isModalVisible, iframeUrl
    } = this.state;
    const {
      closeDocs,
    } = this.props
    return (
      <React.Fragment>
        <Modal 
          title="" 
          closable = { true }
          visible={isModalVisible} 
          onOk={closeDocs} 
          onCancel={closeDocs}
          className="iframeBox"
          footer=""
          width={this.getWidth()}
          height={this.state.boxHeight}>
            <Spin spinning={this.state.loading} tip={'正在加载，请稍候！'} size="large">
              {
                !isMacSsoNoIos && !isSafari && <iframe id='iframe' className="iframe" src={iframeUrl} frameBorder="0"></iframe>}
              {
                (isMacSsoNoIos || isSafari) && <FwDocsMac closeDo cs={closeDocs} doInitializePDFViewerUI={this.props.doInitializePDFViewerUI} />
              }
            </Spin>
            
        </Modal>
        {/* <iframe className="iframe" src="https://docs.foxitcloud.cn/Iframe" frameBorder="0"></iframe> */}
      </React.Fragment>
    );
  }
}
